import {customElement, property} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {DialogAnchorTemplateContent} from "./dialogAnchorTemplateContent";
import Styles from "./inlineModalDialogLink.lit.scss";

@customElement("eop-inline-modal-dialog-link")
export class EopInlineModalDialogLink extends DialogAnchorTemplateContent {

    public static readonly styles = Styles;

    @property({attribute: "style"})
    public linkStyle: string;
    @property()
    public label: string;

    public render(): TemplateResult {
        return html`
            <button type="button" @click=${this.openDialog} @keydown=${this.openDialog}>
                <span class="layer-link link ${this.linkStyle}">${this.label}</span>
            </button>`;
    }
}